// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f178752","239":"e17cc602","488":"a4713326","667":"b011fc25"}[chunkId] + ".chunk.js";
};